import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useIsFirefox } from 'hb-react/shared/hooks/useUserAgent';
import { completeName } from 'helpers/name';

import DisplayUserName from '../components/DisplayUserName';

import style from './index.module.scss';

const ThumbContent = ({ user, showDescription }) => {
  const isFirefox = useIsFirefox();

  return (
    <>
      <img
        data-testid="thumbImage"
        className="block user-item__img"
        src={user.photo_url || user.photo_thumb_url}
        alt={__('%{userName} profil picture').i__({
          userName: completeName(user),
        })}
      />
      <DisplayUserName
        user={user}
        isFirefox={isFirefox}
        showCompleteName={showDescription}
      />
      {showDescription ? (
        <span className="block soft-half--top color-grey break-word">
          <Dotdotdot clamp={0}>{user.description}</Dotdotdot>
        </span>
      ) : (
        <span className="block color-grey break-all">
          <Dotdotdot clamp={isFirefox ? 2 : 1}>{user.headline}</Dotdotdot>
        </span>
      )}
    </>
  );
};

const Thumb = (props) => {
  const { user } = props;
  const { whitelabelURL } = useTopicContext();

  return (
    <div
      className={`inline-block one-quarter push--bottom soft-quarter--sides ${style.component}`}
    >
      <div className="relative">
        {/* Disable link on User if we are in whitelabelURL context */}
        {whitelabelURL ? (
          <ThumbContent {...props} />
        ) : (
          <a href={Routes.user_path(user.user_id || user.id)}>
            <ThumbContent {...props} />
          </a>
        )}
      </div>
    </div>
  );
};

Thumb.propTypes = {
  user: PropTypes.object.isRequired,
  showDescription: PropTypes.bool,
};

export default Thumb;
